import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { selectors as profileSelectors } from '@clearscore/redux.profile';
import memoize from 'lodash.memoize';

const filterRoutesByStatus = (state, routes) => {
    const { accountIDVStatus } = profileSelectors.getStatus(state);
    const routeHasVisibility = ([, { visibility }]) =>
        (Array.isArray(visibility) && visibility.includes(accountIDVStatus)) || !visibility;

    return Object.entries(routes)
        .filter(routeHasVisibility)
        .reduce(
            (visibleRoutes, [route]) => ({
                ...visibleRoutes,
                [route]: routes[route],
            }),
            {},
        );
};

const routesCategories = (state) => resolveProp('entities.routeCategories.byId', state) || [];
const getVisibleRoutes = (state) => filterRoutesByStatus(state, resolveProp('entities.routes.byId', state) || {}) || {};

export default createSelector(routesCategories, getVisibleRoutes, (categories, visibleRoutes) =>
    memoize((category) => {
        const cat = categories[category] || {};
        const { routes = [] } = cat;
        return Object.keys(visibleRoutes).reduce((state, route) => {
            if (routes.includes(route)) {
                state.push({
                    label: visibleRoutes[route].alternativeDisplayName || visibleRoutes[route].displayName,
                    href: visibleRoutes[route].path,
                    isSelected: false,
                    exact: visibleRoutes[route].exact,
                    routeProps: visibleRoutes[route].routeProps || {},
                });
            }
            return state;
        }, []);
    }),
);
